import React, { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from 'theme/GlobalStyle';
import { theme } from 'theme/mainTheme';
import { Helmet } from 'react-helmet';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { database } from 'helpers/firebase';
import MainTemplate from 'templates/MainTemplate';
import Folder from 'views/Folder';
import Login from 'views/Login';
import Upload from 'views/Upload';
import Agenda from 'views/Agenda';
import Notes from 'views/Notes';
import Admin from 'views/Admin';
// import Stream from 'views/Stream';

function Root() {
  const [prevPassword, setPrevPassword] = useState('');
  const [basicPassword, setBasicPassword] = useState('');
  const [isLogged, setIsLogged] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [details, setDetails] = useState(null);
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const [isUpdate, setIsUpdate] = useState(0);
  const [query, setQuery] = useState('');
  const [ip, setIp] = useState(null);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    database.ref('other/password').on('value', (snapshot) => {
      if (snapshot.exists()) {
        setBasicPassword(snapshot.val());
      }
    });

    window
      .fetch('https://geolocation-db.com/json/')
      .then((json) => json.json())
      .then(({ IPv4 }) => setIp(IPv4))
      .catch(() => {
        setIp('blocked');
      });
  }, []);

  useEffect(() => {
    if (prevPassword !== basicPassword && prevPassword.length && !isAdmin) {
      window.location.reload();
      setIsLogged(false);
    }
    setPrevPassword(basicPassword);
  }, [prevPassword, basicPassword]);

  useEffect(() => {
    const arr = [];

    const ref = database.ref('/files');

    ref.once('value').then((snapshot) => {
      snapshot.forEach((childSnapshot) => {
        arr.push({ ...childSnapshot.val(), key: `files/${childSnapshot.key}` });
      });

      setFiles(arr);
      setIsLoading(false);
    });
  }, [isUpdate]);

  useEffect(() => {
    const ref = database.ref('/files');

    ref.on('child_added', () => {
      setIsUpdate((prevState) => prevState + 1);
    });

    ref.on('child_changed', () => {
      setIsUpdate((prevState) => prevState + 1);
    });

    ref.on('child_removed', () => {
      setIsUpdate((prevState) => prevState + 1);
    });
  }, []);

  useEffect(() => {
    if (ip === 'blocked') {
      const { key } = database.ref('other/users').push({ ip: 'blocked' });

      database.ref(`other/users/${key}`).on('value', (snapshot) => {
        if (snapshot.exists()) {
          setUserData({ ...snapshot.val(), key });
        }
      });

      setInterval(() => {
        database.ref(`other/users/${key}`).update({ lastLogin: new Date().getTime() });
      }, 5000);
    } else if (ip) {
      const key = ip.split('.').join('_');
      database
        .ref('other/users')
        .child(key)
        .on('value', (snapshot) => {
          if (snapshot.exists()) {
            setUserData({ ...snapshot.val(), key });
          } else {
            database.ref('other/users').update({
              [key]: {
                ip,
              },
            });
          }
        });

      setInterval(() => {
        database.ref(`other/users/${key}`).update({ lastLogin: new Date().getTime() });
      }, 5000);
    }
  }, [ip]);

  useEffect(() => {
    if (userData.isKick) {
      database
        .ref(`other/users/${userData.key}/isKick`)
        .remove()
        .then(() => {
          window.location.reload();
          setIsLogged(false);
        });
    }
  }, [userData]);

  const handleShowDetails = (key) => {
    setDetails(key);
    setIsDetailsVisible(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@500&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <GlobalStyle />
      <BrowserRouter>
        <LastLocationProvider>
          {!isLogged ? <Redirect to="/login" /> : null}
          <Switch>
            <Route
              path="/login"
              render={() => (
                <Login
                  basicPassword={basicPassword}
                  isLogged={isLogged}
                  setIsLogged={setIsLogged}
                  setIsAdmin={setIsAdmin}
                  setIsAuthorized={setIsAuthorized}
                />
              )}
            />
            <Route path="/admin" render={() => <Admin isAdmin={isAdmin} />} />
            {/* <Route path="/stream" render={() => <Stream isAdmin={isAdmin} />} /> */}
            <Route
              path="/zadania"
              render={() => <Agenda isAdmin={isAdmin} isVerified={isAuthorized} files={files} />}
            />
            <Route
              path="/notatki"
              exact
              render={({ match }) => <Notes match={match} isAdmin={isAdmin} />}
            />
            <Route
              path="/notatki/:noteId"
              render={({ match }) => <Notes match={match} isAdmin={isAdmin} />}
            />
            <MainTemplate
              isLoading={isLoading}
              isDetailsVisible={isDetailsVisible}
              setIsDetailsVisible={setIsDetailsVisible}
              details={details}
              query={query}
              setQuery={setQuery}
              isAdmin={isAdmin}
              isAuthorized={isAuthorized}
            >
              <Route
                path="/"
                exact
                render={() => (
                  <Folder
                    files={files}
                    handleShowDetails={handleShowDetails}
                    isDetailsVisible={isDetailsVisible}
                    match={{ params: { folder: '/' } }}
                    query={query}
                    setQuery={setQuery}
                  />
                )}
              />
              <Route
                path="/przeslij"
                render={() => <Upload isAuth={isAuthorized} isAdmin={isAdmin} />}
              />
              <Route
                path="/f/:folder"
                render={({ match }) => (
                  <Folder
                    match={match}
                    files={files}
                    handleShowDetails={handleShowDetails}
                    isDetailsVisible={isDetailsVisible}
                    query={query}
                    setQuery={setQuery}
                  />
                )}
              />
            </MainTemplate>
          </Switch>
        </LastLocationProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default Root;
